import { Backdrop, styled, Box, Button, Typography, Switch, makeStyles, createStyles, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const BackDropContainer = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

export const Rectangle = styled(Box)(({ theme }) => ({
  minHeight: '627px',
  width: '85%',
  maxWidth: '1110px',
  borderRadius: 6,
  backgroundImage: 'linear-gradient(to bottom, #384b69, #b2c0d5)',
  padding: '52px 206px 37px 204px',
  textAlign: 'center',
  [theme.breakpoints.down('lg')]: {
    paddingInline: '150px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '30px 100px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '40px 50px',
  },
  [theme.breakpoints.down('xs')]: {
    padding: '70px 30px',
  },
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  marginTop: 0,

  padding: '12px 83px 13px 84px',
}));

export const CustomTypography = styled(Typography)(({ size, weight }: { size: number; weight: number }) => ({
  fontSize: size || 16,
  fontWeight: weight || 500,
  textAlign: 'center',
}));

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 90,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    // margin: 1,
    padding: 0,
    top: 9.3,
    transform: 'translateX(9px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(51px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        // backgroundColor: '#151a21',
        backgroundColor: (theme.palette.type === 'dark' ? COLORS.PRIMARY : COLORS.WHITE) + '!important',
      },
      '& .MuiSwitch-thumb': {
        color: '#fff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    // backgroundColor: '#6a788f',
    // backgroundColor: theme.palette.type === 'dark' ? '#6a788f' : COLORS.PRIMARY,
    width: 30,
    height: 15,
    borderRadius: '3px',
    position: 'relative',
    '&:before': {
      content: "'|||'",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 1,
      fontSize: 9.5,
      color: 'darkgray',
      fontWeight: 900,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    // backgroundColor: 'red',
    borderRadius: '5px',
  },
}));

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    switchContent: {
      position: 'absolute',
      left: -5,
      bottom: 20,
      display: 'flex',
      color: '#FFFFFF',
      padding: '10px',
      cursor: 'pointer',
      textDecoration: 'none',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& .MuiFormControlLabel-root': {
        marginRight: '0px',
        marginLeft: '0px',
      },
    },
  }),
);
